import { useIntl } from 'react-intl';
import Image from '@alltrails/core/components/Image';
import getPhotoUrl from '@alltrails/core/utils/getPhotoUrl';
import getPhotoUrlFromId from '@alltrails/core/utils/getPhotoUrlFromId';
import { BREAKPOINT_LG_MARGIN, BREAKPOINT_LG_SIZE, BREAKPOINT_MD_MARGIN, BREAKPOINT_MD_SIZE, SPACE_600 } from '@alltrails/denali/tokens';
import { PhotoHash } from '@/types/shared';
import styles from './PhotoHeaderGrid.module.scss';

// We are using flexbox to create the grid, where the primary image has flex: 5 and the secondary images have flex: 3
const getImageSize = (screenSize: number, secondaryImage: boolean) => (secondaryImage ? screenSize * (3 / 8) : screenSize * (5 / 8));
const secondarySizes = `(max-width: ${BREAKPOINT_MD_SIZE}) ${getImageSize(BREAKPOINT_MD_SIZE - BREAKPOINT_MD_MARGIN * 2, true)}px, ${getImageSize((BREAKPOINT_LG_SIZE - BREAKPOINT_LG_MARGIN * 2) / 2 - SPACE_600, true)}px`;
const primarySizes = `(max-width: ${BREAKPOINT_MD_SIZE}) ${getImageSize(BREAKPOINT_MD_SIZE - BREAKPOINT_MD_MARGIN * 2, false)}px, ${getImageSize((BREAKPOINT_LG_SIZE - BREAKPOINT_LG_MARGIN * 2) / 2 - SPACE_600, false)}px`;

type Props = {
  photo: PhotoHash;
  isPrimary?: boolean;
};

const PhotoGridImage = ({ photo, isPrimary }: Props) => {
  const intl = useIntl();
  const getImageUrl = (photo: PhotoHash) => {
    if (photo?.id && photo?.photoHash) {
      return getPhotoUrl({ isOptimized: true, photo: { id: photo.id, photoHash: photo.photoHash }, size: '1080x700' });
    }
    return getPhotoUrlFromId({ id: photo.id, size: '500x500' });
  };

  return (
    <Image
      className={styles.locationPhoto}
      src={getImageUrl(photo)}
      alt={intl.formatMessage({ defaultMessage: 'Open photo in fullscreen view' })}
      fill
      sizes={isPrimary ? primarySizes : secondarySizes}
      quality={90}
      style={{ transition: 'all 0.3s ease-in-out' }}
      isLcp={isPrimary}
      handleLoadingState={!isPrimary}
    />
  );
};

export default PhotoGridImage;
